import React, { useState, useEffect } from 'react';
import cakeabi from '../../abis/pankakeRouter.json'
import { ethers } from 'ethers';
const Web3 = require('web3-eth');
let tokenB = undefined;
let stakect = 0;
let accountBalancemTB = 0;
let accounts = null
const Modal = (props) => {

  let provider = props.array[0]
  let contract = props.array[1]
  let stakesabi = props.array[2]
  let tokenabi = props.array[4]
  let web3 = provider == "https://bsc-dataseed.binance.org" ? new Web3(new Web3.providers.HttpProvider(provider)) : new Web3(provider)
  const [STAKECTS, setSTAKECTS] = useState(contract);
  const [update, setupdate] = useState('0');
  const [amount, setamount] = useState('0');
  if (provider != null) {
    accounts = [props.array[5]]
    stakect = new web3.Contract(stakesabi, STAKECTS);

    call(stakect.methods.raised, props.setRaised)
    call(stakect.methods.raisedT, props.setRaisedT)
    if (accounts[0] != undefined) {
      callB(accounts)
    }
  }

  function nextblock(accountBalancemctTB, d) {
    return parseFloat(ethers.utils.formatUnits(accountBalancemctTB, d)).toFixed(4)
  }
  async function callB(accounts) {
    accountBalancemTB = await web3.getBalance(accounts[0])
  }
  async function callA(_value) {
    let cake = new web3.Contract(cakeabi, '0x10ED43C718714eb63d5aA57B78B54704E256024E');
    stakect = new web3.Contract(stakesabi, STAKECTS)
    const _amount = await cake.methods.getAmountsOut(value(_value), ['0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c', '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56']).call()
    const _amountB = parseInt(_amount[1]) > 0
      ? _amount[1]
      : 0

    const a = await stakect.methods.raisedT().call()
    const aa = 9 + parseInt(parseInt(nextblock(a, 18)) / 5)

    setamount((parseFloat(nextblock(_amountB, 18)) / aa).toFixed(4))
  }
  async function call(func, callback, ...args) {
    // Trigger the function with the arguments
    func(...args).call()
      .then((result) => {
        // Apply given callback, this is our stateSetters
        callback(result);
      })
      .catch((error) => {

      })
  }
  //new stake
  function value(_value) {
    let a = []
    let e = _value

    if (e.toString().includes(".")) {
      a = e.toString().split(".")
      e = a[0] + a[1] + "0".repeat((18 - a[1].toString().length))
    } else {
      if (e <= 0) {
        e = 0
      } else {
        e = e.toString() + "0".repeat(18)
      }

    }
    return e
  }
  async function nstake(value) {
    if (accounts != null) {
      if (accounts[0] != undefined) {
        let a = []
        let e = value
        let b = false
        if (e.toString().includes(".")) {
          a = e.toString().split(".")
          e = a[0] + a[1] + "0".repeat((18 - a[1].toString().length))
        } else {
          if (e <= 0) {
            e = e.toString() + "0".repeat(18)
            b = true
          } else {
            e = e.toString() + "0".repeat(18)
          }

        }
        if (b) {
          alert("Input invalid")
        } else {
          try {
            const gas = await stakect.methods._buy(e).estimateGas({ from: accounts[0], value: e })
            await stakect.methods._buy(e).send({ from: accounts[0], value: e, gas: gas * 2 })
          } catch (error) {
            console.log(error)
          }

        }
      }
    }
  }
  const SAFE = (props) => {

    return (
      <p style={{ width: "90%", display: "grid", gridTemplateColumns: "auto auto", margin: "auto" }}><span style={{
        textAlign: "left",
        width: "95%",
        fontWeight: "bold",
        color: "#e5e5e5",
        fontSize: "12px"
      }}>{props.what} </span><span style={{
        textAlign: "right",
        width: "100%",
        fontSize: "13px",
        color: props.resultc,
        cursor: props.result.toString().includes("0x") || props.what == "Site:" ? "pointer" : "auto"
      }}>
          {props.result}
        </span></p>
    );
  }
  return (
    <div style={{
      height: "min-content",
      width: "min-content",
      listStyleType: "none",
      display: "grid",
      margin: "auto",
      border: "1px solid " + props.bgcolor,
      color: "#fff",
      fontSize: "12px",
    }}>
      <div style={{
        height: "min-content",
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(270px, 1fr)",
      }}>


        <div style={{ display: "grid", gridTemplateColumns: "auto ", backgroundColor: "#ffffff00", border: "1px solid #ffffff50", height: props.heighti, width: "90%", margin: "auto", marginBottom: "18px", marginTop: "18px", borderRadius: "10px" }}>
          <div style={{
            height: "100%",
            width: "100%",
            margin: "auto",
            display: "grid", gridTemplateColumns: "50px auto 50px",
          }}>
            <i style={{
              height: "100%",
              width: "100%",
              margin: "auto",
              background: "url('" + 'https://bscscan.com/token/images/binance_32.png' + " ')  center center / 50% no-repeat",
            }}>
            </i>
            <div style={{ height: props.heighti, width: "100%", display: "grid", gridTemplateColumns: "100%" }}>
              <input type="number" id={'investINPUT'} onChange={(e) => {
                setupdate(0)
                callA(e.target.value)
              }} placeholder='Amount to invest' style={{ backgroundColor: "#1e293b00", outline: "none", textAlign: "right", border: "none", height: props.heighti, width: "100%", margin: "auto", borderRadius: "10px 0px 0px 10px", color: "#fff", fontSize: "12px" }} />
            </div>
            <p onClick={() => {
              setupdate('0')

              if (document.getElementById('investINPUT') != null) {
                document.getElementById('investINPUT').value = (nextblock(accountBalancemTB, 18) - 0.003).toFixed(4)
                callA((nextblock(accountBalancemTB, 18) - 0.003).toFixed(4))
              } else {
                alert("Erro, Please report")
              }
            }} style={{
              margin: "auto",
              height: "min-content",
              width: "100%",
              display: "grid",
              margin: "auto",
              cursor: "pointer"
            }}><p style={{ margin: "auto", fontWeight: "bold" }}>MAX</p></p>
          </div>
        </div>
        <SAFE what={amount + " BFT"} result={"PER " + (document.getElementById('investINPUT') != null ? document.getElementById('investINPUT').value : "0") + " BNB"} />
       
      </div>
    </div>
  );
}
export default Modal;